/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type { GetApiAccountQueryResponse } from '../models/GetApiAccount.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { getApiAccountQueryResponseSchema } from '../zod/getApiAccountSchema.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const getApiAccountQueryKey = () => [{ url: '/api/account' }] as const;

export type GetApiAccountQueryKey = ReturnType<typeof getApiAccountQueryKey>;

/**
 * {@link /api/account}
 */
export async function getApiAccount(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiAccountQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: 'GET', url: `/api/account`, ...requestConfig });
  return getApiAccountQueryResponseSchema.parse(res.data);
}

export function getApiAccountQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiAccountQueryKey();
  return queryOptions<
    GetApiAccountQueryResponse,
    ResponseErrorConfig<Error>,
    GetApiAccountQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiAccount(config);
    },
  });
}

/**
 * {@link /api/account}
 */
export function useGetApiAccount<
  TData = GetApiAccountQueryResponse,
  TQueryData = GetApiAccountQueryResponse,
  TQueryKey extends QueryKey = GetApiAccountQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiAccountQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiAccountQueryKey();

  const query = useQuery(
    {
      ...getApiAccountQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
